var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-dialog',{attrs:{"isShown":!!_vm.modalUrl,"hasFooter":false},on:{"close":_vm.close}},[_c('img',{staticClass:"picture",attrs:{"src":_vm.modalUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }